import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
import { recoveryClient } from '@/plugins/apiClient';


//import CryptoJS from "crypto-js";
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true, // This is the default
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
const apiClient2 = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: false, // This is the default
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
const apiClient3 = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true, // This is the default
  headers: {
    Accept: 'application/json',
    'Content-Type': 'multipart/form-data',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);
apiClient2.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error: '',
  error400: false,
  successFlag: false,
  users: [],
  allUsers: [],
  totalPages: 0,
  totalRecords: 0,
  user: null,
  errorStatus: null,
  userOtherOrganizations: [],
  userPermisions: [],
  userRoles: [],
  userCitys: [],
  userHospitals: [],
  userStations: [],
  userDetail: null,
  userId: null,
  roleId: [],
  allTechnicians: [],
  isRefreshing: false,
  userProfile: null,
  userProfileAttempt: null,
};
const getters = {};
const mutations = {
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_User(state, user) {
    state.user = user;
  },
  SET_UserCurrent(state, user) {
    state.user = user;
    state.userId = user.id;
    state.roleId = [];
    for (let i = 0; i < user.roles.length; i++) {
      state.roleId.push(user.roles[i].id);
    }
    //state.roleId = user.role.id;
  },
  SET_UserProfile(state, user) {
    state.userProfile = user;
  },

  SET_Users(state, user) {
    state.users = user.items;
    state.totalPages = user.totalPages;
    state.totalRecords = user?.totalRecords ?? 0;
  },
  SET_AllUsers(state, user) {
    state.allUsers = user;
  },
  SET_OtherOrganization(state, data) {
    state.userOtherOrganizations = data;
  },
  SET_Permission(state, data) {
    state.userPermisions = data;
  },
  SET_Role(state, data) {
    state.userRoles = data;
  },
  SET_City(state, data) {
    state.userCitys = data;
  },
  SET_Hospital(state, data) {
    state.userHospitals = data;
  },
  SET_UserDetail(state, data) {
    state.userDetail = data;
  },
  SET_IsRefreshing(state, data) {
    state.isRefreshing = data;
  },
  SET_CurrentAttempts(state, data) {
    state.userProfileAttempt = data;
  },
  SET_AllTechnicians(state, data) {
    state.allTechnicians = data;
  },
  SET_UserStation(state, data) {
    state.userStations = data;
  },
};
const actions = {
  errorUser({ commit }, temperror) {
    var error = temperror;
    if (error) {
      alert;
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getUsersWithPagination(
    { commit, dispatch, rootState },
    { pageNumber, pageSize, fullName, userName, roleId, phoneNumber, nationalCode, personnelNumber },
  ) {
    var url = '/Users/AllPagination?pageNumber=' + pageNumber + '&pageSize=' + pageSize;
    if (fullName) {
      url += '&FullName=' + fullName;
    }
    if (personnelNumber) {
      url += '&personnelNumber=' + personnelNumber;
    }
    if (userName) {
      url += '&userName=' + userName;
    }
    if (phoneNumber) {
      url += '&phoneNumber=' + phoneNumber;
    }
    if (roleId) {
      if (roleId.length > 0) {
        for (let i = 0; i < roleId.length; i++) {
          url += '&RoleIds=' + roleId[i];
        }
      }
    }
    if (nationalCode) {
      url += '&NationalCode=' + nationalCode;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_Users', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUser', error);
      });
  },
  getAllUsers({ commit, dispatch, rootState }, params) {
    return apiClient
      .get('/Users/All', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
        params,
      })
      .then((response) => {
        commit('SET_AllUsers', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUser', error);
      });
  },
  addUser({ commit, dispatch, rootState }, user) {
    return apiClient
      .post('/users', user, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUser', error);
      });
  },
  getUser({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/users/ById?userId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_User', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUser', error);
      });
  },
  getUserCurrent({ commit, dispatch, rootState }) {
    return apiClient
      .get('/users/Current', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_Status', true);
        commit('SET_UserCurrent', response.data);
      })
      .catch((error) => {
        dispatch('errorUser', error);
      });
  },
  getUserProfile({ commit, dispatch, rootState }) {
    return apiClient
      .get('/users/Current', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_Status', true);
        commit('SET_UserProfile', response.data);
      })
      .catch((error) => {
        dispatch('errorUser', error);
      });
  },
  getUserDetail({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/users/ByIdWithDetails?userId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_UserDetail', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUser', error);
      });
  },
  editUser({ commit, dispatch, rootState }, user) {
    return apiClient
      .post('/Users/Edit', user, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUser', error);
      });
  },
  setPasswordForUser({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/Users/SetPassword', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUser', error);
      });
  },
  activeUser({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/users/Enable?id=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUser', error);
      });
  },
  deactiveUser({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/users/Disable?id=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUser', error);
      });
  },
  userOtherOrganizations({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/users/OtherOrganizations?userId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_Status', true);
        commit('SET_OtherOrganization', response.data);
      })
      .catch((error) => {
        dispatch('errorUser', error);
      });
  },
  editUserOtherOrganization({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/Users/OtherOrganizations', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUser', error);
      });
  },
  userPrmissions({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/users/Permissions?userId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_Status', true);
        commit('SET_Permission', response.data);
      })
      .catch((error) => {
        dispatch('errorUser', error);
      });
  },
  //   stations
  getUserAllStationsDispatch({ commit, dispatch, rootState }, params) {
    return apiClient
      .get('/users/stations', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
        params,
      })
      .then((response) => {
        commit('SET_Status', true);
        commit('SET_UserStation', response.data);
      })
      .catch((error) => {
        dispatch('errorUser', error);
      });
  },
  setUserStationsDispatch({ commit, dispatch, rootState }, body) {
    return apiClient
      .post('/Users/Stations', body, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUser', error);
      });
  },
  editUserPermission({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/Users/Permissions', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUser', error);
      });
  },
  userRoles({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/users/Roles?userId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_Status', true);
        commit('SET_Role', response.data);
      })
      .catch((error) => {
        dispatch('errorUser', error);
      });
  },
  editUserRole({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/Users/Roles', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUser', error);
      });
  },
  userCitys({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/users/Cities?userId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_Status', true);
        commit('SET_City', response.data);
      })
      .catch((error) => {
        dispatch('errorUser', error);
      });
  },
  editUserCity({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/Users/Cities', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUser', error);
      });
  },
  userHospitals({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/users/Hospitals?userId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_Status', true);
        commit('SET_Hospital', response.data);
      })
      .catch((error) => {
        dispatch('errorUser', error);
      });
  },
  editUserHospital({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/Users/Hospitals', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUser', error);
      });
  },
  logOut({ commit, dispatch, rootState }) {
    return apiClient
      .post('/Users/logout', {}, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUser', error);
      });
  },
  changeCurrentUserPassword({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/Users/ChangePassword', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUser', error);
      });
  },
  editCurrentUser({ commit, dispatch, rootState }, user) {
    return apiClient
      .post('/Users/profile', user, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUser', error);
      });
  },
  unBlockUser({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/Users/' + id + '/Unblock',
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUser', error);
      });
  },
  changeImage({ commit, dispatch, rootState }, data) {
    return apiClient3
      .post('/Users/Image', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUser', error);
      });
  },
  refreshToken({ commit, dispatch, state, rootState }) {
    if (state.isRefreshing) {
      return;
    }
    commit('SET_IsRefreshing', true);
    return apiClient
      .post('/Users/RefreshToken', {}, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((res) => {
        if (
          res.status === 200 ||
          res.status === 201 ||
          res.status === 202 ||
          res.status === 203 ||
          res.status === 204
        ) {
          dispatch('csrf', {}, { root: true });
          commit('SET_Status', true);
        } else {
          commit('SET_Status', false);
        }
        commit('SET_IsRefreshing', false);
      })
      .catch(() => {
        commit('SET_Status', false);
        // commit("SET_RefreshingError", error);
        commit('SET_IsRefreshing', false);
      });
  },


  refreshToken_New({ commit, rootState }) {
    return recoveryClient
      .post('/Users/RefreshToken', {},
        { headers: { 'X-CSRF-Token:': rootState.loginModule.csrf, }, }
      )
      .then((response) => {
        commit('SET_Status', true);
        commit('SET_IsRefreshing', false);
        return response;
      })
      .catch((error) => {
        commit('SET_Status', false);
        commit('SET_IsRefreshing', false);
        throw error;
      });
  },


  setExtension({ commit, dispatch, rootState }, data) {
    return apiClient
      .post(
        '/Users/Extension?extensionId=' + data,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUser', error);
      });
  },
  setZone({ commit, dispatch, rootState }, data) {
    return apiClient
      .post(
        '/Users/Zone?zoneId=' + data,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUser', error);
      });
  },
  otpRequest({ commit, dispatch }, phoneNumber) {
    return apiClient2
      .post('/Users/OTPRequest?phoneNumber=' + phoneNumber)
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUser', error);
      });
  },
  oTPVerify({ commit, dispatch }, data) {
    return apiClient2
      .post('/Users/OTPVerify', data)
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUser', error);
      });
  },
  oTPChangePassword({ commit, dispatch }, data) {
    return apiClient2
      .post('/Users/OTPChangePassword', data)
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUser', error);
      });
  },
  getCurrentAttempt({ commit, dispatch, rootState }) {
    return apiClient
      .get('/Users/CurrentAttempts', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_CurrentAttempts', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUser', error);
      });
  },
  getAllTechnicians({ commit, dispatch, rootState }) {
    return apiClient
      .get('/Users/Technicians', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllTechnicians', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUser', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
